import { useAdmin } from '../../hooks/useAdmin';
import Analytics from './Analytics';

export default function AdminDashboard() {
  const { requireAdmin } = useAdmin();

  // Require admin access
  requireAdmin();

  return <Analytics />;
}
